export const loadScript = src => {
  const tag = document.createElement('script')
  tag.setAttribute('src', src)
  tag.setAttribute('type', 'text/javascript')
  document.body.appendChild(tag)
}

export const loadCss = href => {
  const tag = document.createElement('link')
  tag.setAttribute('href', href)
  tag.setAttribute('rel', 'stylesheet')
  document.head.appendChild(tag)
}
